var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelephoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.64,
    height: 15.146,
    viewBox: "0 0 14.64 15.146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_353432_phone_telephone_communication_icon",
    "data-name": "353432_phone_telephone_communication_icon",
    transform: "translate(-8.872 -8.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23581",
    "data-name": "Path 23581",
    d: "M20.375,22.579s-.468-.543-.79-.543h-.267v-1.25a.633.633,0,1,0-1.266,0v1.25H16.442v-1.25a.633.633,0,1,0-1.266,0v1.25h-.268c-.322,0-.789.543-.789.543l-3.463,3.233a.809.809,0,0,0-.241.506v4a1.163,1.163,0,0,0,1.163,1.163H22.916a1.163,1.163,0,0,0,1.163-1.163v-4a.809.809,0,0,0-.241-.506ZM22.5,29.893H12V26.724l3.2-2.989.056-.051.056-.065h3.871l.051.059.062.058,3.2,2.989v3.169Z",
    transform: "translate(-1.055 -8.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23582",
    "data-name": "Path 23582",
    d: "M18.764,8.073H13.62a4.749,4.749,0,0,0-4.748,4.749v.634a.324.324,0,0,0,.324.323h2.915a.791.791,0,0,0,.792-.791V11.357a.791.791,0,0,1,.791-.791h5a.792.792,0,0,1,.792.791v1.631a.791.791,0,0,0,.791.791h2.916a.323.323,0,0,0,.323-.323v-.634A4.748,4.748,0,0,0,18.764,8.073Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23583",
    "data-name": "Path 23583",
    d: "M26.784,33.638A2.416,2.416,0,1,0,29.2,36.054,2.416,2.416,0,0,0,26.784,33.638Zm0,3.005a.59.59,0,1,1,.59-.59A.59.59,0,0,1,26.784,36.643Z",
    transform: "translate(-10.591 -17.474)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneIcon);
export default __webpack_public_path__ + "static/media/telephone_icon.0822287ffaa2b82e4ac507596790beb3.svg";
export { ForwardRef as ReactComponent };